import * as yup from 'yup';
import { ptShort } from 'yup-locale-pt';

yup.setLocale(ptShort);

export const createGroupSchema = yup.object().shape({
  name: yup.string().required(),
  desc: yup.string().required()
});
